import { render, staticRenderFns } from "./AssemblyDetails.vue?vue&type=template&id=069a82fa"
import script from "./AssemblyDetails.vue?vue&type=script&lang=js"
export * from "./AssemblyDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports